export default {
    name: 'rendez-vous-suivant',
    components: {},
    props: ['consultation', 'is_printable'],
    data() {
        return {

        }
    },
    computed: {

    },
    mounted() {

    },
    methods: {
        formatDateDDMMYYY: function(given_date) {
            let date = new Date(given_date)
            let month = date.getMonth() + 1,
                day = date.getDate();

            if (month < 10) month = '0' + month
            if (day < 10) day = '0' + day
            let date_to_return = `${day}/${month}/${date.getFullYear()}`;
            return date_to_return
        }
    }
}